import { useTranslation } from 'react-i18next'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { useHelpCenter } from '@/HelpCenter/ui/context/HelpCenterContext'
import {
    OreButton,
    OreDivider,
    OreStack,
} from '@edenredespana/oreneta'

export const ReopenTicketFooter = (): JSX.Element => {
    const { t } = useTranslation()
    const { handleReopenCancel, saveTicketReopen, isReopenFormValid } = useHelpCenter()

    return (
        <OreStack space="medium" placeContent="stretch">
            <OreDivider />
            <OreStack space="large" direction="row" placeContent="space-between">
                <OreButton onClick={handleReopenCancel} category={'secondary'}>
                    {t(HelpCenterTranslations.cancel)}
                </OreButton>
                <OreButton
                    onClick={saveTicketReopen}
                    category={'primary'}
                    disabled={!isReopenFormValid}
                >{t(HelpCenterTranslations.submit)}</OreButton>
            </OreStack>
        </OreStack>
    )
}


